<alaris-dialog [closeAction]="close.bind(this)"
			   [confirmAction]="confirm.bind(this)"
			   [loading$]="service.loading$"
			   size="md">
	<h6 slot="header">{{ 'system_codes.removing_dialog' | translate }}</h6>
    <div slot="content">
        <h5><strong>{{ data.code.ID }}</strong></h5>
        @if(rules.length > 0) {
            <hr class="divider" />
            <span>{{ 'system_codes.removing_rules' | translate }}</span><br>
            @for(rule of rules; track rule) {
                <span><strong>{{ 'ID: ' + rule.ID + '\n' + 'Name: ' + rule.Name }}</strong></span><br>
            }
        }
    </div>
</alaris-dialog>